<template>
  <v-layout align-center justify-center py-4>
    <h4 class="defaultColor--text font-weight-regular">{{ defaultText }}</h4>
  </v-layout>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  data: () => ({

  }),
  watch: {},
  computed: {
    defaultText(){
        if(this.text != ''){
            return this.text
        }else{
          return this.$t('description.noPost')  
        } 
    }
  },
};
</script>
